import { createSlice } from '@reduxjs/toolkit'
import type { InputList } from 'common/api/v1/types'
import type { ApplicationException } from '../../api/ApplicationException'
import {
  clearInputList,
  clearInputLists,
  createInputList,
  getInputList,
  getInputLists,
  removeInputList,
  removeInputLists,
  updateInputList,
} from '../actions/inputListsActions'
import { logoutUser } from '../actions/userActions'
import { isOneOf } from '../actions'
import { createLoadingReducer } from './shared'

interface State {
  formErrors?: ApplicationException['errorInfo']['details']
  loading: boolean
  inputList?: InputList
  inputLists: InputList[]
  saving?: boolean
  total: number
}

export const initialStateInputLists: State = { inputLists: [], loading: false, total: 0 }
const { isLoadingAction, loadingReducer } = createLoadingReducer<State>(removeInputList, getInputLists)

const inputListsSlice = createSlice({
  name: 'inputLists',
  initialState: initialStateInputLists,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getInputLists.fulfilled, (state, { payload: { items, total } }) => ({
        ...state,
        inputLists: items,
        total,
      }))
      .addCase(getInputList.fulfilled, (state, { payload }) => ({ ...state, inputList: payload }))
      .addCase(clearInputList, (state) => ({ ...state, inputList: undefined, formErrors: undefined }))
      .addCase(clearInputLists, (state) => ({ ...state, inputLists: [] }))
      .addCase(logoutUser.fulfilled, () => initialStateInputLists)
      .addCase(removeInputList.fulfilled, (state, { payload }) => ({
        ...state,
        inputLists: state.inputLists.filter(({ id }) => id !== payload.id),
        total: state.total - 1,
      }))
      .addCase(removeInputLists.fulfilled, (state, { payload }) => ({
        ...state,
        inputLists: state.inputLists.filter(({ id }) => !payload.includes(id)),
        total: state.total - payload.length,
      }))
      .addMatcher(isOneOf([updateInputList.pending, createInputList.pending]), (state) => ({ ...state, saving: true }))
      .addMatcher(isOneOf([createInputList.fulfilled, updateInputList.fulfilled]), (state) => ({
        ...state,
        saving: undefined,
        formErrors: undefined,
      }))
      .addMatcher(isOneOf([updateInputList.rejected, createInputList.rejected]), (state, { payload }) => ({
        ...state,
        saving: false,
        formErrors: payload?.details,
      }))
      .addMatcher(isLoadingAction, loadingReducer)
  },
})

export default inputListsSlice.reducer
